export default class Animations {
    static init() {
        return new Animations();
    }

    constructor() {
        const splitItems = document.querySelectorAll('.split-text');

        if (splitItems)
            this.initItems(splitItems);

        const animatedButtonBackgrounds = document.querySelectorAll('.button-primary, .button-secondary');

        if (animatedButtonBackgrounds)
            this.initButtonBackgrounds(animatedButtonBackgrounds);
    }

    initItems(items) {
        items.forEach(item => {
            item.innerHTML = '<div><span>' + item.textContent.trim().split('').join('</span><span>') + '</span></div>';
        })
    }

    initButtonBackgrounds(buttons) {
        buttons.forEach((button) => {
            button.addEventListener('mouseenter', (e) => {
                const background = button.querySelector(".animated-background");
                const buttonPos = button.getBoundingClientRect();
                const relX = e.clientX - buttonPos.x;
                const relY = e.clientY - buttonPos.y;
                background.style.top = relY + 'px';
                background.style.left = relX + 'px';
            });

            button.addEventListener('mouseout', (e) => {
                const background = button.querySelector(".animated-background");
                const buttonPos = button.getBoundingClientRect();
                const relX = e.clientX - buttonPos.x;
                const relY = e.clientY - buttonPos.y;

                background.style.top = relY + 'px';
                background.style.left = relX + 'px';
            });
        })
    }
}